import React from 'react';

// Line icons for each Marketplace item type, from the store-page prototype. Drawn in
// currentColor and sized at 1em, so they sit wherever a type emoji used to (type cards,
// a listing with no icon of its own) and take that spot's color and font size.
export type GlyphType = 'skill' | 'agent' | 'workflow' | 'widget' | 'mcp_server' | 'integration';

const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 16, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };

const GLYPHS: Record<GlyphType, React.ReactNode> = {
  // A document.
  skill: (<>
    <path d="M86 56 H150 L178 84 V200 H86 Z" {...stroke}/>
    <path d="M108 120 H156 M108 150 H156" {...stroke} strokeWidth={14}/>
  </>),
  // A shield with a check.
  agent: (<>
    <path d="M128 56 L186 78 V126 C186 162 160 188 128 200 C96 188 70 162 70 126 V78 Z" {...stroke}/>
    <path d="M104 128 L122 146 L156 110" {...stroke}/>
  </>),
  // A magnifier: tools an agent can look things up with.
  mcp_server: (<>
    <circle cx="116" cy="116" r="46" {...stroke}/>
    <path d="M150 150 L192 192" {...stroke} strokeWidth={18}/>
  </>),
  // A plug.
  integration: (<path d="M100 60 V96 M156 60 V96 M84 96 H172 V128 C172 152 152 170 128 170 C104 170 84 152 84 128 Z M128 170 V200" {...stroke}/>),
  // Bars.
  widget: (<>
    <rect x="70" y="138" width="30" height="56" rx="8" fill="currentColor"/>
    <rect x="113" y="104" width="30" height="90" rx="8" fill="currentColor"/>
    <rect x="156" y="66" width="30" height="128" rx="8" fill="currentColor"/>
  </>),
  // A branching flow.
  workflow: (<>
    <circle cx="80" cy="128" r="18" fill="currentColor"/>
    <circle cx="176" cy="80" r="18" fill="currentColor"/>
    <circle cx="176" cy="176" r="18" fill="currentColor"/>
    <path d="M96 120 L160 88 M96 136 L160 168" {...stroke} strokeWidth={12}/>
  </>),
};

const TypeGlyph: React.FC<{ type: GlyphType; className?: string }> = ({ type, className }) => (
  <svg className={className} viewBox="40 40 176 176" width="1em" height="1em" aria-hidden="true" focusable="false">
    {GLYPHS[type] ?? GLYPHS.skill}
  </svg>
);

export default TypeGlyph;
